
import { FreightCollectInfo, ReturnOrderLineModel, ShippingContact, StandardReturnResult, SubmitReturnStatus, WizardStepKey } from "@dana/Services/DanaStandardReturnOrderService";
import { SalseOrgDetails } from "@dana/Services/StandardReturnDetailsService";
import StandardReturnOrderState from "@dana/Store/Data/StandardReturns/StandardReturnOrderState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: StandardReturnOrderState = {
    isLoading: false,
    filteredQuery: "",
    selectedOrder: undefined,
    selectedLines: [],
    reason: undefined,
    disposition: undefined,
    shippingContact: undefined,
    internalRefNumber: "",
    freightCollectInfo: undefined,
    emailContacts: [],
    submitStatus: "IDLE",
    rmaDocumentGenerated: false,
    currentStep: "SELECT_ITEMS",
    carrier: undefined,
    dispositionPreferences: undefined,
    standardReturnReasons: undefined,
    submitedOrderNumber: undefined,
    salseOrgDetails:undefined
};

// Create Immer reducer
const standardReturnOrderReducer = createTypedReducerWithImmer(initialState, {
    "StandardReturn/Init": draft => {
        Object.assign(draft, initialState)
    },
    "StandardReturn/IsLoading": (draft: Draft<StandardReturnOrderState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
    },
    "StandardReturn/PopulateResult": (draft: Draft<StandardReturnOrderState>, action: { data: StandardReturnResult }) => {
        draft.selectedOrder = action.data.returnOrderModel;
        draft.selectedLines = action.data.returnOrderModel?.returnOrderLines;
        draft.carrier = action.data.carrier;
        draft.dispositionPreferences = action.data.dispositionPreferences;
        draft.standardReturnReasons = action.data.standardReturnReasons;

    },
    "StandardReturn/UpdateSelectedLines": (draft: Draft<StandardReturnOrderState>, action: { selectedLines: ReturnOrderLineModel[] }) => {
        draft.selectedLines = action.selectedLines;
    },
    "StandardReturn/UpdateFilterQuery": (draft: Draft<StandardReturnOrderState>, action: { filteredQuery: string }) => {
        draft.filteredQuery = action.filteredQuery;
    },
    "StandardReturn/UpdateReason": (draft: Draft<StandardReturnOrderState>, action: { reason: string }) => {
        draft.reason = action.reason;
    },
    "StandardReturn/UpdateCurrentStepContacts": (draft: Draft<StandardReturnOrderState>, action: { currentStep: WizardStepKey }) => {
        draft.currentStep = action.currentStep;
    },
    "StandardReturn/UpdateDisposition": (draft: Draft<StandardReturnOrderState>, action: { disposition: string }) => {
        draft.disposition = action.disposition;
    },
    "StandardReturn/UpdateFreightCollectInfo": (draft: Draft<StandardReturnOrderState>, action: { freightCollectInfo: FreightCollectInfo }) => {

        draft.freightCollectInfo = action.freightCollectInfo;
        Object.assign(draft.freightCollectInfo, action.freightCollectInfo)
    },
    "StandardReturn/UpdateShippingContact": (draft: Draft<StandardReturnOrderState>, action: { shippingContact: ShippingContact }) => {
        draft.shippingContact = action.shippingContact;
    },
    "StandardReturn/UpdateInternalRefNumber": (draft: Draft<StandardReturnOrderState>, action: { internalRefNumber: string }) => {
        draft.internalRefNumber = action.internalRefNumber;
    },
    "StandardReturn/UpdateEmailContacts": (draft: Draft<StandardReturnOrderState>, action: { emailContacts: string[] }) => {
        draft.emailContacts = action.emailContacts;
    },
    "StandardReturn/UpdateSubmitStatus": (draft: Draft<StandardReturnOrderState>, action: { submitStatus: SubmitReturnStatus }) => {
        draft.submitStatus = action.submitStatus;
    },
    "StandardReturn/PopulateSubmitOrderResult": (draft: Draft<StandardReturnOrderState>, action: { orderNumber: string,salseOrgDetails:SalseOrgDetails }) => {
        draft.submitedOrderNumber = action.orderNumber;
        draft.salseOrgDetails = action.salseOrgDetails;
    },
});

// Register reducer in the root
(reducers as any).standardReturnState = standardReturnOrderReducer;

// Define type for action usage
type DanaStandardReturnOrderReducer = {
    standardReturnState: typeof standardReturnOrderReducer;
};

export type DanaStandardReturnOrderActions = Parameters<DanaStandardReturnOrderReducer[keyof DanaStandardReturnOrderReducer]>[1] | AnyAction;
